import React, {useContext,useEffect,useState} from 'react'
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer, Button, TableRow, Paper,Typography } from '@mui/material';
import {useHelper} from '../hooks/useHelper'
import { formularioContext } from '../contextos/FormularioContext'

export const ETMostrarDatosVenta = ({venta,
                            datosMinistroUad,
                            descripcionProvincia,
                            email_default,
                            item_a_pagar,
                            index,
                            matrimonio,
                            esUltimo})=>{
    const datosInscPrincipal = index==undefined;
    const {formatearMontoMoneda}= useHelper()
    const {updateContingente_o_grupo} = useContext(formularioContext)
    

    return  (
    <Box sx={{ maxWidth: 500, margin: 'auto', mt: 2,background:'black' }}>
    <TableContainer component={Paper} sx={{ maxWidth: 400, margin: 'auto', mt: 2 }}>
      <Table size="small">
        <TableBody>
        {datosInscPrincipal && <TableRow>
            <TableCell>
                <Typography variant="h6" sx={{ textAlign: 'left' }}>
       Inscribir a:
      </Typography>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>}
          {! datosInscPrincipal && <TableRow>
            <TableCell><span className='font-bold'>{matrimonio ? 'Cónyuge' : `Inscripto asociado:`}</span></TableCell>
            <TableCell>
                {matrimonio && <Button variant='outlined' onClick={()=>updateContingente_o_grupo(venta,true,true)}>borrar</Button>}
                {!matrimonio && <span>`(${index+1})`</span>}
            </TableCell>
          </TableRow>}
          <TableRow>
            <TableCell>Nombre</TableCell>
            <TableCell>{getDatos('nombre',datosMinistroUad,venta)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Documento</TableCell>
            <TableCell>{getDatos('dni',datosMinistroUad,venta)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Sexo</TableCell>
            <TableCell>{getDatos('sexo',datosMinistroUad,venta)}</TableCell>
          </TableRow>
           <TableRow>
            <TableCell>Edad</TableCell>
            <TableCell>{getDatos('edad',datosMinistroUad,venta)}</TableCell>
          </TableRow>
         <TableRow>
            <TableCell>Provincia</TableCell>
            <TableCell>{descripcionProvincia(getDatos('id_provincia',datosMinistroUad,venta))}</TableCell>
          </TableRow>
        {datosInscPrincipal && <TableRow>
            <TableCell>e-mail</TableCell>
            <TableCell>{email_default}</TableCell>
          </TableRow>}
        </TableBody>
      </Table>
    </TableContainer>
    {/* {(item_a_pagar?.cant_max_personas==1 || esUltimo) && <TableContainer component={Paper} sx={{ maxWidth: 400, margin: 'auto', mt: 2 }}>
        <Table size="small">
            <TableBody>
                <TableRow>
                    <TableCell>
                     <Typography variant="h6" sx={{ textAlign: 'left',marginTop:'1.5rem' }}>
                        Tipo de entrada: 
                    </Typography>
                </TableCell>
                <TableCell>
                     <Typography variant="h6" sx={{ textAlign: 'left',marginTop:'1.5rem' }}>
                        {item_a_pagar?.detalle} 
                    </Typography>
                </TableCell>
            </TableRow>
            <TableRow>
                    <TableCell>
                     <Typography variant="h6" sx={{ textAlign: 'left',marginTop:'1.5rem' }}>
                        Precio: 
                    </Typography>
                </TableCell>
                <TableCell>
                     <Typography variant="h6" sx={{ textAlign: 'left',marginTop:'1.5rem' }}>
                        $ {formatearMontoMoneda(item_a_pagar?.valor)} 
                    </Typography>
                </TableCell>
            </TableRow>
            </TableBody>
        </Table>
    </TableContainer>}           */}
    {/* {(item_a_pagar?.cant_max_personas==1 || esUltimo) &&  <Typography variant="h6" sx={{ textAlign: 'left',marginTop:'1.5rem' }}>
       Tipo de entrada: {item_a_pagar?.detalle}
      </Typography>} */}
    </Box>)


        return <Box style={{borderTop:'solid 1px',fontSize:'small'}}>
            <table> 
                <tr>
                    <td>{getDatos('nombre',datosMinistroUad,venta)} (DNI:{getDatos('dni',datosMinistroUad,venta)})</td>
                    <td>{getDatos('edad',datosMinistroUad,venta)} años {getDatos('sexo',datosMinistroUad,venta)==='M' ? ` (Hombre)`: ' (Mujer)'}</td>
                </tr>
                {datosInscPrincipal && <tr>
                    <td>E-mail: {email_default}</td>
                    <td></td>
                </tr>}
                {(!datosInscPrincipal && matrimonio) && <tr>
                    <td>Cónyuge</td>
                    <td></td>
                </tr>}
            </table>
        </Box>
}

const getDatos = (campo,datosMinistroUad,venta)=>{
    const esMinistroUad = venta?.ministroUad==='ministrouad';

    switch (campo){
        case 'nombre': return  esMinistroUad ? datosMinistroUad?.nombre : `${venta?.nombre} ${venta?.apellido}` 
        case 'dni': return esMinistroUad ? datosMinistroUad?.nro_documento : `${venta?.documento || venta?.nro_documento}`
        case 'email': return esMinistroUad ? datosMinistroUad?.email : `${venta?.email}`
        case 'sexo': return esMinistroUad ? convertSexo(datosMinistroUad?.sexo) : `${convertSexo(venta?.sexo)}`
        case 'edad': return esMinistroUad ? datosMinistroUad?.edad : `${venta?.edad} años`
        case 'id_provincia': return esMinistroUad ? datosMinistroUad?.id_provincia : `${venta?.id_provincia}`

    }
}

const convertSexo = (sexo)=>{
    if(sexo=='F'){
        return 'Femenino'
    }else{
        return 'Masculino'
    }
}